import { mapRecordFromServer, mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { IRequestPayload } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';
import { IPartBom, IPartBomDetails, IUpsertPartBomPayload } from 'partBoms/types';
import { PartType } from 'parts/enums';

export const getPartBoms = async (requestPayload: IRequestPayload, signal?: AbortSignal) => {
  const { data } = await partfinitiClient.get(
    `/part_v2/bom-list/boms?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<IPartBom>(data.data, data.recordsFiltered, data.totals);
};

export const getPartBom = async (criteria: { part: { id: number } }, signal?: AbortSignal) => {
  const { data } = await partfinitiClient.get(
    `/part_v2/bom-list/bom?${getQueryStringToSnakeCase(criteria)}`,
    signal
  );

  return mapRecordFromServer<IPartBomDetails>(data.part, data.success);
};

export const upsertPartBom = async (data: IUpsertPartBomPayload) => {
  const payload = {
    ...data,
    part: {
      ...data.part,
      type: PartType.BOM,
    },
  };

  return partfinitiClient.postForm('/part_v2/index/save', payload, { includeNullValues: true });
};

export const removePartBom = async (data: { ids: number[] }) =>
  partfinitiClient.postForm('/part_v2/bom-edit/remove', data);
